import React, { Component } from 'react'
import propTypes from 'prop-types'
import { observer } from 'mobx-react'
import get from 'lodash/get'
import map from 'lodash/map'

import Radio from '@components/Form/Radio'

class RadioGroup extends Component {
  static propTypes = {
    form: propTypes.object,
    field: propTypes.shape({
      name: propTypes.string
    }).isRequired,
    label: propTypes.oneOfType([propTypes.string, propTypes.element]),
    onChange: propTypes.func,
    options: propTypes.array.isRequired,
    inline: propTypes.bool,
    disabled: propTypes.bool
  }

  render () {
    const {
      form,
      field,
      label,
      onChange,
      options,
      inline,
      disabled
    } = this.props
    return (
      <div className='expert-form__input-group subindustry-wrapper'>
        <label
          className={`expert-form__label${
            inline ? '' : ' expert-form__label--reset-line-height'
          }`}
        >
          {label}
        </label>
        <div className='expert-form__input-wrapper'>
          <div
            className={`radio-group__container ${
              inline ? 'radio-group__container--inline' : ''
            }`}
          >
            {map(options, (option, index) => {
              return (
                <div
                  key={index}
                  className={`radio-group__item ${
                    inline ? 'radio-group__item--inline' : ''
                  }`}
                  onClick={() => {
                    const pickedOption = option.value || option
                    if (disabled) return
                    if (!onChange) {
                      form.setFieldValue(field.name, pickedOption, false)
                      form.setFieldTouched(field.name, true)
                    } else {
                      onChange(option)
                    }
                  }}
                >
                  <Radio
                    onChange={() => null}
                    checked={
                      (option.value || option) === get(form.values, field.name)
                    }
                    disabled={disabled}
                  />
                  <div className='radio-group__item__label'>
                    {option.label || option}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default observer(RadioGroup)
